// Counter.js - Fixed version with correct response handling
import React, { useState, useContext, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
// import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css";
import PageNotFound from '../FallBackUI/PageNotFound';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import WebSocketCaller from '../WebSocket/WebSocket';
import { CountContext } from "../Context/Allcontext";

const Counter = (props) => {
  const [counter, setCounter] = useState('');
  const sellerData = useSelector(state => state.LoginReducer.payload);
  const [errorcounter, setErrorCounter] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const [confirmationFlag, setConfirmationFlag] = useState(false);
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Single state to control which screen to show: 'form' | 'confirm' | 'result'
  const [screen, setScreen] = useState('form');

  const { send } = WebSocketCaller();
  const { webData } = useContext(CountContext);
  
  const responseProcessedRef = useRef(false);
  const isSubmittingRef = useRef(false); // ref to avoid stale closure
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  // In Counter.js, update the useEffect to handle the array response more robustly:

useEffect(() => {
    console.log("Counter - webData received:", webData); // Add this for debugging
    console.log("Counter - isSubmittingRef.current:", isSubmittingRef.current);
    console.log("Counter - responseProcessedRef.current:", responseProcessedRef.current);
    
    if (!webData || responseProcessedRef.current || !isSubmittingRef.current) {
        console.log("Counter - Early return conditions met");
        return;
    }

    let isSuccess = false;
    let errorMessage = null;

    // Handle [{ success: true }] - your current structure
    if (Array.isArray(webData) && webData.length > 0) {
        const firstItem = webData[0];
        if (firstItem && typeof firstItem === 'object' && firstItem.success !== undefined) {
            if (firstItem.success === true) {
                isSuccess = true;
                console.log("Counter - Success detected in array response");
            } else if (firstItem.success === false) {
                errorMessage = firstItem.message || firstItem.error || "Failed to submit counter bid";
                console.log("Counter - Error detected in array response:", errorMessage);
            }
        }
    }
    
    // Handle direct { success: true } object
    if (!isSuccess && !errorMessage && webData.success !== undefined) {
        if (webData.success === true) {
            isSuccess = true;
            console.log("Counter - Success detected in object response");
        } else if (webData.success === false) {
            errorMessage = webData.message || webData.error || "Failed to submit counter bid";
            console.log("Counter - Error detected in object response:", errorMessage);
        }
    }

    if (!isSuccess && !errorMessage) {
        console.log("Counter - No success or error message found in response");
        return;
    }

    // Mark as processed
    responseProcessedRef.current = true;
    isSubmittingRef.current = false;
    setIsSubmitting(false);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    if (isSuccess) {
        console.log("Counter - Setting success popup");
        setAlertImg(checkImg);
        setAlertTitle("Counter Bid Successfully Given");
        setAlertMessage("Thank you so much for your business.");
        setScreen('result');
        props.counterBitUpdateFlag(true);
        if (props.handleCounter) props.handleCounter();
    } else {
        console.log("Counter - Setting error popup:", errorMessage);
        setAlertImg(errorImg);
        setAlertTitle("Error");
        setAlertMessage(errorMessage);
        setScreen('result');
    }
}, [webData]); // Ensure all dependencies are included

  const validateCounter = () => {
    setErrorCounter("");
    if (props.time == null || props.time == 0) {
      if (!counter || counter === '') {
        setErrorCounter("Counter Bid is required");
        return false;
      }
      const counterNum = Number(counter);
      if (counterNum <= props.highBid) {
        setErrorCounter("Counter Bid cannot be less than or equal to high bid");
        return false;
      }
      if (props.sellitNow && counterNum >= props.sellitNow) {
        setErrorCounter("Counter Bid cannot be greater than or equal to sell it Now price");
        return false;
      }
    } else {
      if (!counter && !props.newBid) {
        setErrorCounter("Counter Bid is required");
        return false;
      }
      const counterNum = Number(counter || props.newBid);
      if (counterNum <= props.highBid) {
        setErrorCounter("Counter Bid cannot be less than or equal to high bid");
        return false;
      }
    }
    return true;
  };

  const Counterok = () => {
    if (!validateCounter()) return;

    if (screen === 'form') {
      setScreen('confirm');
      return;
    }

    // Confirmed — submit
    responseProcessedRef.current = false;
    isSubmittingRef.current = true;
    setIsSubmitting(true);

    const finalCounterBid = counter ? Number(counter) : Number(props.newBid);

    const wsMessage = {
      UpdatedData: {
        car_id: props.carId,
        seller_dealer_id: sellerData.seller_dealer_id,
        counter_bid: finalCounterBid,
        updatedBy: sellerData.seller_id,
        createdBy: sellerData.seller_id,
        seller_id: sellerData.seller_id,
        seller_token: sellerData.seller_token,
        car_max_price: props.sellitNow
      },
      model: "counter_bid"
    };

    const sent = send(wsMessage);

    timeoutRef.current = setTimeout(() => {
      if (isSubmittingRef.current && !responseProcessedRef.current) {
        console.log("WebSocket timeout, falling back to HTTP");
        sendViaHttp();
      }
    }, 10000);

    if (!sent) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      sendViaHttp();
    }
  };

  const sendViaHttp = () => {
    const finalCounterBid = counter ? Number(counter) : Number(props.newBid);
    const request = {
      car_id: props.carId,
      seller_dealer_id: sellerData.seller_dealer_id,
      counter_bid: finalCounterBid,
      updatedBy: sellerData.seller_id,
      createdBy: sellerData.seller_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
      car_max_price: props.sellitNow
    };
    API.post("counter_bid/add", request)
      .then(response => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        if (response.data.success) {
          setAlertImg(checkImg);
          setAlertTitle("Counter Bid Successfully Given");
          setAlertMessage("Thank you so much for your business.");
          props.counterBitUpdateFlag(true);
          if (props.handleCounter) props.handleCounter();
        } else {
          setAlertImg(errorImg);
          setAlertTitle("Error");
          setAlertMessage(response.data.error?.err || "Failed to submit counter bid");
        }
        setScreen('result');
      })
      .catch(error => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        setAlertImg(errorImg);
        setAlertTitle("Error");
        setAlertMessage(error.response?.data?.error || "Network error");
        setScreen('result');
      });
  };

  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setCounter(value);
    setErrorCounter("");
  };

  const handleCloseAll = () => {
    setScreen('form');
    props.toggle();
  };

  // Result popup (success or error)
  if (screen === 'result') {
    return (
      <Modal show={true} onHide={handleCloseAll} centered backdrop="static">
        <Modal.Header className='Terms-login'>
          <h2>{alerttitle}</h2>
        </Modal.Header>
        <Modal.Body>
          <div className="Commonfull-icon">
            <img
              alt=""
              className={alertimg === checkImg ? "successImg" : "errorImg"}
              src={alertimg}
            />
          </div>
          <div className="text-center">
            <p>{alertmessage}</p>
          </div>
          <div className="inactivebtns text-center">
            <button className="cta-btns" onClick={handleCloseAll}>OK</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // Form / Confirm popup
  return (
    <Modal show={true} onHide={props.toggle} centered backdrop="static">
      <Modal.Header className='Terms-login'>
        <h2>Counter Bid</h2>
      </Modal.Header>
      <Modal.Body>
        {screen === 'form' ? (
          <div className='counterbit-pop'>
            <div className="col-lg-12">
              <input className="textbox curSymbol" type="text" value="$" readOnly />
              {props.time == null || props.time == 0 ? (
                <input
                  className="textbox cunBid"
                  type="text"
                  placeholder="Enter Your Counter Bid"
                  value={counter}
                  onChange={numberPattern}
                  autoFocus
                />
              ) : (
                <input
                  className="textbox cunBid"
                  type="text"
                  placeholder="Enter Your Counter Bid"
                  defaultValue={props.newBid}
                  onChange={numberPattern}
                  autoFocus
                />
              )}
            </div>
            <p className="form-input-error">{errorcounter}</p>
            <div className="inactivebtns">
              <button className="cta-btns" onClick={props.toggle}>Cancel</button>
              <button className="cta-btns" onClick={Counterok}>OK</button>
            </div>
          </div>
        ) : (
          <div>
            <p className="deletemsg">
              Are you sure you want to submit the counter bid for <b>${counter || props.newBid}</b>?
            </p>
            <div className="inactivebtns">
              <button
                className="cta-btns"
                onClick={() => setScreen('form')}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                className="cta-btns"
                onClick={Counterok}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Confirm"}
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Counter;